/**
 * customize-product-al-v1 Component.
 *
 */
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { CartService, CommonService, IConfigObj, IEstimatedTotalRequestPayload, IModifier, IModifierOption, SelectedModifierAndOptions, QtyStepperOptions, CustomizationDetails, CartV2Service, AemService } from 'abs-ngx-library/src/lib/core';
import { CustomizeProductALV1Service } from './customize-product-al-v1.service';
import { map } from 'rxjs';

@Component({
    selector: 'customize-product-al-v1',
    templateUrl: './customize-product-al-v1.component.html'
})

export class CustomizeProductAlV1Component implements OnInit {

    @Input() product: any;
    @Input() configObj: IConfigObj;
    @Input() customizationDetails: CustomizationDetails;
    public productDescription = '';
    public estimatedPrice: number;
    public productQty: number = 1;
    public clonedProduct: any;
    public selectedModifierAndOptions: SelectedModifierAndOptions = {};
    private debounceUpdateEstimation: any;
    public preferencesText: string = '';
    public qtyStepperOptions: QtyStepperOptions = {
        ctaLabel: 'Add to cart',
        quantity: 1,
        modifierOptionUPCs: { isValid: false, upcs: [] },
        isCustomizationEditFlow: false,
        customizationEditSource: '',
        comments: '',
        isValid: false,
        options: []
    };
    public isCateringEnabled: boolean;
    private isCartEditFlow: boolean = false;
    private cartDataProcessed: boolean = false;

    constructor(
        public elementRef: ElementRef,
        public commonService: CommonService,
        public cutomizeAlV1service: CustomizeProductALV1Service,
        public cartService: CartService,
        public cartV2Service: CartV2Service,
        private _aemService: AemService,
        
    ) {
        this.debounceUpdateEstimation = this.commonService.debounce(this.updateEstimation, 600).bind(this);
    }


    public ngOnInit() {
        this.isCateringEnabled = !this._aemService.getFeatureFlagByNameDisable('isCateringDisabled');
        this.clonedProduct = this.commonService.cloneDeep(this.product);
        if (this.product?.productDetail?.details?.length > 0) {
            this.product?.productDetail?.details.forEach((detail: any) => {
                if (detail.header.includes('Details')) {
                    this.productDescription = detail.value;
                }
            });
        }
        this.analyticsTrackCustomize();
        this.estimatedPrice = this.commonService.getValidProductPrice(this.product);
        this.product['modifiers'] = this.product?.['modifiers']?.sort((a, b) => a.sortId - b.sortId);
        this.initSelectedModifierAndOptions();
        this.updateCustomizationDataFromLocalIfExists();
    }

    /**
     * Initializes the selected modifiers and options based on the customization details.
     * This method checks if the customization flow is in edit mode and updates the
     * selected customizations accordingly, ensuring that the component reflects the
     * current state of the product's customizations.
     */
    public initSelectedModifierAndOptions(): void {
        if (this.customizationDetails?.flowType === 'edit') {
            if (this.customizationDetails?.src === 'BIA') {
                let selectedOptions = [];
                if (this.isCateringEnabled && this.product?.previousCustomizations?.length > 0) {
                    selectedOptions = this.product.previousCustomizations.map((item: any) => ({ upcId: item.option, qty: item.quantity }));
                } else {
                    selectedOptions = this.product?.selectedCustomizations?.length > 0 ? this.product.selectedCustomizations : [];
                }
                if (selectedOptions.length > 0 && !this.commonService.customizationData().isUpdated) {
                    this.commonService.updateCustomizationData({
                        productId: this.product.id,
                        selectedOptions,
                        comments: this.product?.preferences,
                    });
                }
            } else {
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType);
                let obs = this.commonService.currentCartObj;
                obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));
                this.isCartEditFlow = true;
                obs.subscribe(objCart => {
                    // Only process cart data once to avoid overwriting user changes
                    if (this.cartDataProcessed) {
                        return;
                    }
                    if (!this.commonService.isEmpty(objCart)) {
                        this.cartDataProcessed = true;
                        const matchingItem = objCart.cartItems?.find(item => item.itemId == this.product.id && item.entryId == this.customizationDetails?.entryId);
                        if (!this.commonService.isEmpty(matchingItem)) {
                            this.qtyStepperOptions.ctaLabel = "Update";
                            this.qtyStepperOptions.isCustomizationEditFlow = true;
                            this.qtyStepperOptions.customizationEditSource = this.customizationDetails?.src;
                            this.qtyStepperOptions.entryId = matchingItem?.entryId;
                            const selectedOptionsFromCart = this.isCateringEnabled
                                ? matchingItem?.options?.map((opt: any) => {
                                    const mod = this.getModifierByOptionUpcId(opt.upcId);
                                    const qty = mod ? ((typeof opt.qty === 'number') ? opt.qty : (opt.isSelected ? 1 : 0)) : 0;
                                    return { upcId: opt.upcId || '', qty };
                                    })
                                : matchingItem?.options?.map((opt: any) => opt.upcId || this.setInitialSelectedModifierAndOptions());

                            this.commonService.updateCustomizationData({
                                productId: this.product.id,
                                selectedOptions:  selectedOptionsFromCart,
                                selectedQuantity: this.cutomizeAlV1service.isLBProduct(this.product) ? matchingItem?.selectedWeight : (matchingItem?.qty ?? matchingItem?.quantity),
                                comments: matchingItem?.comments
                            });
                            this.updateCustomizationDataFromLocalIfExists();
                        }
                    }
                });
            }

        }
    }

    /**
     * Updates the customization data from signal  if it has been updated.
     * This method checks if the customization data is updated and matches the current product ID.
     * If so, it retrieves the pre-selected modifier options and updates the quantity if exists.
     */
    public updateCustomizationDataFromLocalIfExists(): void {
        // Skip setting default selections if we're waiting for cart data in cart edit flow
        if (this.isCartEditFlow && !this.cartDataProcessed) {
            return;
        }
        if (this.commonService.customizationData().isUpdated && this.commonService.customizationData().productId === this.product.id) {
            // Always restore selectedModifierAndOptions and optionQuantities from signal
            if (this.commonService.customizationData().selectedOptions?.length) {
                this.selectedModifierAndOptions = this.cutomizeAlV1service.getPreSelectedModifierAndOptions(this.product?.['modifiers'], this.commonService.customizationData().selectedOptions);
            } else {
                this.setInitialSelectedModifierAndOptions();
            }
            if (this.commonService.customizationData().selectedQuantity) {
                this.setProductQty(this.commonService.customizationData().selectedQuantity);
            } else {
                this.setProductQty(this.cutomizeAlV1service.isLBProduct(this.product) ? this.product.incrementPriceList?.[0]?.weight : 1);
            }
            if (this.commonService.customizationData().comments) {
                this.setPreferencesText(this.commonService.customizationData().comments);
            }
        } else {
            this.setInitialSelectedModifierAndOptions();
            this.setProductQty(this.cutomizeAlV1service.isLBProduct(this.product) ? this.product.incrementPriceList?.[0]?.weight : 1);
        }
        this.updateQtySteppermodifierOptionUPCs();
        this.updateEstimation();
    }

    // Update estimation by calling the API or fallback to client-side calculation
    private updateEstimation(): void {
        // Use quantities from option.qty for selected options
        const selectedOptions = this.cutomizeAlV1service.getAllModifierSelectedOptions(this.selectedModifierAndOptions) || [];
        const selectedModifiers = selectedOptions.map((option: any) => {
            const modifier = this.getModifierByOptionUpcId(option.upcId);
            const optionQuantity = (typeof option.qty === 'number') ? option.qty : 1;
            const response: any = { id: option.upcId ?? '', price: (option.price ?? 0).toString() };
            if (this.isCateringEnabled && modifier && modifier.stepperEnabled && optionQuantity > 0) {
                response.quantity = optionQuantity;
            }
            return response;
        });

        const requestPayload: IEstimatedTotalRequestPayload = {
            bpn: this.product.id,
            price: this.cutomizeAlV1service.getItemPrice(this.product, this.productQty),
            quantity: this.getProductQtyForPriceEstimation(),
            selectedModifiers
        };
        this.cutomizeAlV1service.getEstimatedTotal(requestPayload)
            .subscribe({
                next: (response: any) => {
                    this.estimatedPrice = response.estimatedPrice;
                },
                error: (error: any) => {
                    this.calculateClientSideEstimation();
                }
            });
    }

    // get product quantity
    private getProductQtyForPriceEstimation(): number {
        return this.cutomizeAlV1service.isLBProduct(this.product) ? 1 : this.productQty;
    }

    // Get Updated Quantity of the product
    public getUpdatedQty(quantity): void {
        this.commonService.updateCustomizationData({
            productId: this.product.id,
            selectedQuantity: quantity
        })
        this.setProductQty(quantity);
        this.debounceUpdateEstimation();
    }

    /**
     * Sets the product quantity and updates the quantity in the stepper options.
     *
     * @param quantity - The desired quantity to set for the product.
     */
    private setProductQty(quantity: number): void {
        this.productQty = quantity;
        this.qtyStepperOptions.quantity = quantity;
    };

    // Fallback client-side calculation
    private calculateClientSideEstimation(): void {
        const allSelectedOptions = this.cutomizeAlV1service.getAllModifierSelectedOptions(this.selectedModifierAndOptions) || [];
        let additionalCosts = 0;
        if (this.isCateringEnabled) {
            additionalCosts = allSelectedOptions.reduce((total: number, option: any) => {
                const modifier = this.getModifierByOptionUpcId(option.upcId);
                const optionQuantity = (typeof option.qty === 'number') ? option.qty : 1;
                return total + ((option.price || 0) * optionQuantity);
            }, 0);
        } else {
            additionalCosts = allSelectedOptions.reduce((total: number, option: any) => total + (option.price || 0), 0);
        }
        this.estimatedPrice = this.getProductQtyForPriceEstimation() * (+this.cutomizeAlV1service.getItemPrice(this.product, this.productQty) + additionalCosts);
    }

    /**
     * Updates the preferences text with the provided value.
     *
     * @param value - The new string value to set as the preferences text.
     */
    public updateChar(value: string) {
        this.commonService.updateCustomizationData({
            productId: this.product.id,
            comments: value
        });
        this.setPreferencesText(value);
    }

     /**
     * Sets the preferencesText and updates the comments in stepper options.
     */
    public setPreferencesText(value: string) {
        this.preferencesText = value;
        this.qtyStepperOptions.comments = value;
    }

    /**
     * Scrolls smoothly to the first element with the class `svg-caution` within the component's DOM.
     * If such elements are found, the first one is scrolled into view with a smooth animation,
     * aligning it to the center of the viewport.
     *
     */
    public scrollToFirstMissingCustomization() {
        const firstCautionElement = this.elementRef.nativeElement.querySelectorAll('.svg-caution')[0]?.closest('.customize-selection');

        if (firstCautionElement) {
            firstCautionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private getModifierSelectionType(modifier: IModifier): 'single' | 'multi' | 'optional' | '' {
        if (!this.commonService.isEmpty(modifier)) {
            switch (true) {
                case modifier.minSelect === 1 && modifier.maxSelect === 1:
                    return 'single';
                case (!modifier.minSelect && !modifier.maxSelect) || (modifier.minSelect === 0 && modifier.maxSelect === 0):
                    return 'optional';
                default:
                    return 'multi';
            }
        }
        return '';
    }

    /**
     * Handles the selection of an option within a modifier.
     * Updates the selection state of the option and manages the selected options
     * for single-select and multi-select modifiers. Triggers an estimation update
     * if the selected option has a price greater than zero.
     *
     * @param modifier - The modifier object containing the options and selection rules.
     * @param option - The specific option being selected or deselected.
     * @param event - The DOM event triggered by the selection action.
     */
    public onOptionSelect(modifier: IModifier, option: IModifierOption, event: Event): void {
        const isQtyStepperEnabled = this.isCateringEnabled && modifier?.stepperEnabled;
        // If stepper emitted a removal and set suppression flag, prevent the checkbox change toggling logic
        if ((option as any)?.deSelect) {
            delete (option as any).deSelect;
            option.isSelected = false;
            if (isQtyStepperEnabled) option.qty = 0;
        }
        
        option.isSelected = !option.isSelected;
        // Always start a fresh selection with quantity 1 when stepper is enabled.
        if (isQtyStepperEnabled) option.qty = option.isSelected ? 1 : 0;

        const isSingleSelect = this.getModifierSelectionType(modifier) === 'single';
        const isMultiSelect = this.getModifierSelectionType(modifier) === 'multi';
        const optionalSelect = this.getModifierSelectionType(modifier) === 'optional';
        const isNoCustomization = option.name?.startsWith('No');
        const selectedOptions = this.selectedModifierAndOptions[modifier.name] || [];
        if (isNoCustomization) {
            // Deselect all other options in the category and clear their quantities
            selectedOptions.forEach((opt: any) => {
                if (opt.upcId !== option.upcId) {
                    opt.isSelected = false;
                    if (isQtyStepperEnabled) opt.qty = 0;
                }
            });

            if (option.isSelected) {
                // If "No" customization is selected, set only this option
                this.selectedModifierAndOptions[modifier.name] = [option];
                // Set qty to 0 for "No" options
                if (isQtyStepperEnabled) option.qty = 0;
                this.updateSelectedOptionsAndSync(modifier, option, 0);
            } else {
                // If "No" customization is deselected, clear selection
                this.selectedModifierAndOptions[modifier.name] = [];
                this.updateSelectedOptionsAndSync(modifier, option, 0);
            }
            // If a priced customization is removed, update the estimated total
            if (selectedOptions.some(opt => opt.price > 0)) {
                this.debounceUpdateEstimation();
            }
        } else {
            if (isSingleSelect) {
                if (selectedOptions[0]) {
                    selectedOptions[0].isSelected = false;
                    if (isQtyStepperEnabled) selectedOptions[0].qty = 0;
                }
                delete this.selectedModifierAndOptions[modifier.name];
                // Select the current option with qty 1
                this.updateSelectedOptionsAndSync(modifier, option, 1);
            } else if (isMultiSelect || optionalSelect) {
                const optionIndex = selectedOptions.findIndex(opt => opt.upcId === option.upcId);
                const isChecked = (event.target as HTMLInputElement).checked;

                if (isChecked && optionIndex === -1) {
                    let totalQuanity = 0;
                    for (const opt of selectedOptions) {
                        totalQuanity += (typeof opt.qty === 'number') ? opt.qty : (opt.isSelected ? 1 : 0);
                    }
                    const canAdd = optionalSelect || !modifier.maxSelect || (isQtyStepperEnabled ? totalQuanity : selectedOptions.length) < modifier.maxSelect;
                    if (canAdd) {
                        // Add option with its current qty or 1
                        // Always initialize a newly added option with qty 1
                        this.updateSelectedOptionsAndSync(modifier, option, 1);
                    } else {
                        (event.target as HTMLInputElement).checked = false;
                        option.isSelected = false;
                        if (option.price > 0) return;
                    }
                } else if (!isChecked && optionIndex !== -1) {
                    // Remove option
                    this.updateSelectedOptionsAndSync(modifier, option, 0);
                }

                // Deselect "No" customization if another option is selected
                const noCustomizationOptionIndex = this.selectedModifierAndOptions?.[modifier.name]?.findIndex(opt => opt?.name?.startsWith('No'));
                if (noCustomizationOptionIndex !== -1) {
                    const noCustomizationOption = this.selectedModifierAndOptions[modifier.name][noCustomizationOptionIndex];
                    noCustomizationOption.isSelected = false;
                    if (isQtyStepperEnabled) noCustomizationOption.qty = 0;
                    this.selectedModifierAndOptions[modifier.name].splice(noCustomizationOptionIndex, 1);
                }
            }
            if (option?.price > 0 || (isSingleSelect && selectedOptions.some(opt => opt.price > 0))) {
                this.debounceUpdateEstimation();
            }
        }
    }

    private updateSelectedOptionsAndSync(modifier: any, option: any, quantity: number): void {
        const isQtyStepperEnabled = this.isCateringEnabled && modifier?.stepperEnabled;
        const selectedOptions = this.selectedModifierAndOptions[modifier.name] || [];
        const optionIndex = selectedOptions.findIndex((opt: any) => opt.upcId === option.upcId);
        const isNoCustomization = option.name?.startsWith('No');

        if (quantity <= 0) {
            option.isSelected = false;
            if(isQtyStepperEnabled) option.qty = 0;
            if (optionIndex > -1) {
                // Only remove if not a 'No' option
                if (!isNoCustomization) {
                    selectedOptions.splice(optionIndex, 1);
                } else {
                    // For 'No' option, keep it in selectedOptions but set qty to 0 and isSelected true
                    option.isSelected = true;
                    if (isQtyStepperEnabled) option.qty = 0;
                    selectedOptions[optionIndex] = option;
                }
                if (selectedOptions.length === 0) {
                    delete this.selectedModifierAndOptions[modifier.name];
                } else {
                    this.selectedModifierAndOptions[modifier.name] = selectedOptions;
                }
            }
        } else {
            option.isSelected = true;
            if (isQtyStepperEnabled){
                option.qty = quantity;
                if (optionIndex > -1) {
                    selectedOptions[optionIndex].qty = quantity;
                } else {
                    selectedOptions.push(option);
                }
            }else{
                selectedOptions.push(option);
            }
            this.selectedModifierAndOptions[modifier.name] = selectedOptions;
        }

        this.updateQtySteppermodifierOptionUPCs();
        if(option.price > 0) {
            this.debounceUpdateEstimation();
        }   
        // send different shapes to signal based on feature flag
        const allSelectedOptions = this.cutomizeAlV1service.getAllModifierSelectedOptions(this.selectedModifierAndOptions);

        const selectedOptionsForSignal = this.isCateringEnabled
            ? allSelectedOptions.map((opt: any) => {
                const mod = this.getModifierByOptionUpcId(opt.upcId);
                const qty = mod ? ((typeof opt.qty === 'number') ? opt.qty : (opt.isSelected ? 1 : 0)) : 0;
                return { upcId: opt.upcId || '', qty };
                })
            : allSelectedOptions.map((opt: any) => opt.upcId || '');

        this.commonService.updateCustomizationData({
            productId: this.product.id,
            selectedOptions: selectedOptionsForSignal
        });
    }

    /**
     * Sets the initial selected modifiers and options based on the product's modifiers.
     * This method initializes the `selectedModifierAndOptions` property with the
     * default selections for each modifier, ensuring that the component starts with
     * a consistent state.
     */
    private setInitialSelectedModifierAndOptions(): void {
        this.selectedModifierAndOptions = this.cutomizeAlV1service.getInitialSelectedModifierAndOptions(this.product?.['modifiers']);

        // Update customization data with initial selected options only if not already updated
        if (!this.commonService.customizationData().isUpdated) {
            const allSelectedOptions = this.cutomizeAlV1service.getAllModifierSelectedOptions(this.selectedModifierAndOptions);
            const selectedOptionsForSignal = this.isCateringEnabled
                ? allSelectedOptions.map((opt: any) => {
                    const mod = this.getModifierByOptionUpcId(opt.upcId);
                    const qty = mod ? ((typeof opt.qty === 'number') ? opt.qty : (opt.isSelected ? 1 : 0)) : 0;
                    return { upcId: opt.upcId || '', qty };
                    })
                : allSelectedOptions.map((opt: any) => opt.upcId || '');

            this.commonService.updateCustomizationData({
                productId: this.product.id,
                selectedOptions: selectedOptionsForSignal
            });
        }
    }

    /**
     * Updates the UPCs of the selected modifier options in the quantity stepper options.
     * This method checks if the selections are valid and updates the `modifierOptionUPCs`
     * property accordingly, ensuring that the quantity stepper reflects the current state
     * of selected modifiers and options.
     */
    public updateQtySteppermodifierOptionUPCs(): void {
        const selectedOptions = this.cutomizeAlV1service.getAllModifierSelectedOptions(this.selectedModifierAndOptions);
        if (this.isCateringEnabled) {
            this.qtyStepperOptions.options = selectedOptions.map(opt => {
                if (opt.qty > 0) {
                    return { upcId: opt.upcId || '', qty: opt.qty };
                } else {
                    return { upcId: opt.upcId || '' };
                }
            });
            this.qtyStepperOptions.isValid = this.cutomizeAlV1service.isValidSelections(this.product?.['modifiers'], this.selectedModifierAndOptions);
        } else {
            this.qtyStepperOptions.modifierOptionUPCs = {
                isValid: this.cutomizeAlV1service.isValidSelections(this.product?.['modifiers'], this.selectedModifierAndOptions),
                upcs: selectedOptions.map(option => option.upcId || ''),
            };
        }
     }

    public analyticsTrackCustomize () {
        if (window['AB']?.DATALAYER) {
            window['AB'].DATALAYER.productInfo(this.product);
            window['AB'].DATALAYER.setModalViewEvents('deli:customize-item|view');
        }
    }

    /**
      * Handles quantity changes from the stepper component
      * Updates local selectedModifierAndOptions, deselects option if quantity is 0, and syncs with signal
      */
    public handleQuantityChange(modifier: any, option: any, newQuantity: number) {
        if (!this.isCateringEnabled) return;
        this.updateSelectedOptionsAndSync(modifier, option, newQuantity);
    }

    /**
     * Helper to get modifier by option UPC ID
     */
    private getModifierByOptionUpcId(upcId: string): any {
        if (!this.product?.['modifiers']) return null;
        return this.product['modifiers'].find((modifier: any) =>
            modifier.options?.some((opt: any) => opt.upcId === upcId)
        );
    }

    /**
     * Returns the formatted price string for an option, handling catering logic.
     */
    public getOptionPriceDisplay(option: any): string {
        if (!option) return '';
        if (this.isCateringEnabled && option.qty > 0) {
            return (option.price * option.qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
        return (option.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    /**
     * Returns the aria-label string for an option, handling catering logic and accessibility.
     */
    public getOptionAriaLabel(modifier: any, option: any, index: number, isOOS: boolean): string {
        if (this.isCateringEnabled && modifier.stepperEnabled) {
            if (((option.qty && option.qty > 0) || option.isSelected)) {
                return (
                    (option.qty) + ' ' +
                    (option.qty === 1 ? 'unit of ' : 'units of ') +
                    (option?.name || '') + ' ' +
                    (option?.temperature?.toLowerCase() === 'hot' ? ' (not SNAP eligible) ' : '') +
                    (option.baseCalories ? option.baseCalories + ' Calories ' : '') +
                    (option.price ? (option.price * option.qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' More for each topping ' : '') +
                    (index + 1) + ' of ' + (modifier?.options?.length || 0) +
                    (isOOS ? ' Out of stock' : '')
                );
            } else {
                return (
                    (option?.name || '') + ' ' +
                    (option?.temperature?.toLowerCase() === 'hot' ? ' (not SNAP eligible) ' : '') +
                    (option.baseCalories ? option.baseCalories + ' Calories ' : '') +
                    (option.price ? option.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' More for each topping ' : '') +
                    (index + 1) + ' of ' + (modifier?.options?.length || 0) +
                    ' items' + (isOOS ? ' Out of stock' : '')
                );
            }
        } else {
            return (
                (option?.name || '') + ' ' +
                (option?.temperature?.toLowerCase() === 'hot' ? ' (not SNAP eligible) ' : '') +
                (option.baseCalories ? option.baseCalories + ' Calories ' : '') +
                (option.price ? option.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' More for each topping ' : '') +
                (isOOS ? ' Out of stock' : '')
            );
        }
    }

    /**
     * Returns true if the total quantity selected for a given modifier has reached maxSelect.
     */
    public getTotalSelectedQtyForModifier(modifier: any): boolean {
        if (!modifier?.options) return false;
        const customizationData = this.commonService.customizationData();
        return this.commonService.isMaxQuantityReachedForModifier(modifier, customizationData.selectedOptions);
    }

    /**
     * Checks if the minimum selection requirement is satisfied for a given modifier.
     * Uses different validation logic based on whether catering is enabled and stepper is enabled.
     */
    public isMinSelectSatisfied(modifier: any): boolean {
        if (this.isCateringEnabled && modifier.stepperEnabled) {
            return this.commonService.isMinSelectSatisfied(modifier, this.commonService.customizationData().selectedOptions);
        } else {
            return this.selectedModifierAndOptions[modifier.name]?.length >= modifier.minSelect;
        }
    }
}
